<template>
  <div style="padding: 16px">
    <div style="padding-bottom: 16px">
      <div style="margin-bottom: 8px">
        <p>応募者情報をcsv形式でエクスポートできます。</p>
        <p>エクスポートしたい期間を指定してください。</p>
      </div>
      <div style="display: flex; align-items: center; margin-top: 16px">
        <div style="width: 240px">
          <input
            class="input"
            type="month"
            name="monthFrom"
            v-model="exportMonthFrom"
            :max="thisMonth"
          />
        </div>
        <p>　～　</p>
        <div style="width: 240px">
          <input
            class="input"
            type="month"
            name="monthTo"
            v-model="exportMonthTo"
            :max="thisMonth"
          />
        </div>
      </div>
    </div>
    <div>
      <b-checkbox v-model="is_string">
        電話番号を文字列化してエクスポートする
      </b-checkbox>
    </div>
    <div>
      <b-checkbox v-model="is_recruitpage">
        応募元の求人ページ情報をエクスポートする(HRモンスター求人)
      </b-checkbox>
    </div>
    <div>
      <b-checkbox v-model="is_filter_column">
        選択された項目のみをエクスポートする(インポート不可)
      </b-checkbox>
    </div>
    <div class="tab-box" v-if="is_filter_column">
      <b-tabs v-model="filter_tab">
        <!-- 項目から選択 -->
        <b-tab-item label="項目">
          <div class="tab-box-item-header">
            <button @click="selectAllColumn" class="button mini-button">すべて選択</button>
            <button @click="unselectAllColumn" class="button mini-button">クリア</button>
            <button @click="openTemplateModal()" class="button mini-button">+ 選択項目をテンプレートに保存</button>
          </div>
          <div class="tab-box-item disp-scroll">
            <div v-for="(column) in companyColumnSetting" v-if="!column.is_delete" :key="column.id">
              <b-checkbox :value="selected_columns[column.pk]" @input="selectColumn(column.pk, $event)">{{ column.name }}</b-checkbox>
            </div>
          </div>
        </b-tab-item>
        <!-- テンプレートから選択 -->
        <b-tab-item label="テンプレート">
          <div class="no-template" v-if="seekerExportTemplates.length == 0">テンプレートは作成されていません</div>
          <div class="tab-box-template disp-scroll">
            <div class="template-row" v-for="(template) in seekerExportTemplates">
              <div class="template-label">
                <input type="radio" name="template" class="radio-input"
                  v-model="selected_template_id" :value="template.id" :id="template.id"/>
                <label :for="template.id">{{ template.name }}</label>
              </div>
              <button class="edit-btn button is-small"
                @click="openTemplateModal(template)">
                <span class="mdi mdi-square-edit-outline mdi-16px"></span>
              </button>
            </div>
          </div>
        </b-tab-item>
      </b-tabs>
    </div>
    <div style="margin-top: 5px">
      <button
        @click="executeCsvExport(exportMonthFrom, exportMonthTo, is_string,is_recruitpage, getIncludedColumnList())"
        class="button is-primary is-fullwidth"
        :disabled="!exportMonthFrom || !exportMonthTo || isMakingCSV || noTemplate"
      >
        <template v-if="!isMakingCSV">エクスポート</template>
        <template v-else
          ><span class="mdi mdi-loading mdi-spin" style="margin-right: 5px"></span
          >作成中です</template
        >
      </button>
    </div>

    <!-- テンプレートモーダル -->
    <BasicModal
      :isShowModal="show_template_modal"
      title="エクスポートテンプレート"
      width="480px"
      :canCancel="true"
      @cancel="closeTemplateModal"
    >
      <ModalSeekerExportTemplate
        :is_new="filter_tab === 0"
        :template="editing_template"
        :filter_columns="selected_columns"
        @close="closeTemplateModal"
      />
    </BasicModal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import BasicModal from '@/components/Modals/BasicModal'
import ModalSeekerExportTemplate from '../modals/ModalSeekerExportTemplate.vue';

export default {
  props: {
    executeCsvExport: {
      type: Function,
      required: true,
    },
    thisMonth: {
      type: String,
      required: true,
    },
    isMakingCSV: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    BasicModal,
    ModalSeekerExportTemplate,
  },
  computed: {
    ...mapState('auth', ['companyColumnSetting']),
    ...mapState('directtalk', ['seekerExportTemplates']),
    noTemplate() {
      return this.is_filter_column && this.filter_tab === 1 && this.seekerExportTemplates.length === 0
    },
  },
  mounted() {
    this.$store.dispatch('directtalk/getSeekerExportTemplate')

    this.selected_columns = this.companyColumnSetting.reduce((obj, column) => {
      obj[column.pk] = true
      return obj
    }, {})
  },
  watch: {
    seekerExportTemplates() {
      if (this.seekerExportTemplates.findIndex((template) => template.id === this.selected_template_id) === -1) this.selected_template_id = null
      if (this.selected_template_id == null && 0 < this.seekerExportTemplates.length) this.selected_template_id = this.seekerExportTemplates[0].id
    },
  },
  data() {
    return {
      exportMonthFrom: '',
      exportMonthTo: '',
      is_string: false,
      is_recruitpage: false,
      is_filter_column: false,
      show_template_modal: false,
      filter_tab: 0,
      selected_columns: {},
      selected_template_id: null,
      editing_template: null
    }
  },
  methods: {
    openTemplateModal(template = null) {
      this.editing_template = template;
      this.show_template_modal = true;
    },
    closeTemplateModal() {
      this.show_template_modal = false;
    },
    selectColumn(index, value) {
      this.selected_columns[index] = value
    },
    selectAllColumn() {
      for (const column of this.companyColumnSetting) {
        if (!column.is_delete) {
          this.selected_columns[column.pk] = true
        }
      }
    },
    unselectAllColumn() {
      for (const column of this.companyColumnSetting) {
        if (!column.is_delete) {
          this.selected_columns[column.pk] = false
        }
      }
    },
    getIncludedColumnList() {
      if (this.is_filter_column) {
        if (this.filter_tab === 0) {
          return Object.keys(this.selected_columns).filter((key) => this.selected_columns[key])
        } else {
          return this.selected_template_id ? this.seekerExportTemplates.find((template) => template.id === this.selected_template_id).columns : []
        }        
      } else {
        return null
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.tab-box {
  background: white;
  border: solid thin #ccc;
  border-radius: 8px;
  height: 400px;
  padding: 0px 16px 16px 16px;
  margin-top: 16px;
}

.tab-box-item-header {
  display: flex;
  justify-content: space-between;
  margin: 4px 0px;
}

.tab-box-item {
  height: 310px;
}

.tab-box-template {
  height: 334px;
  margin: 8px 0px;
}

.mini-button {
  font-size: small;
  height: 24px;
}

.radio-input {
  display: none;
}
.radio-input + label {
  display: inline-block;
  padding-left: 20px;
  padding-top: 7px;
  position: relative;
  font-size: 14px;
  width: 350px;
  cursor: pointer;
  overflow-x: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.radio-input + label::before {
  content: '';
  display: block;
  position: absolute;
  top: 10px;
  left: 0;
  width: 15px;
  height: 15px;
  border: 1px solid #999;
  border-radius: 50%;
}
.radio-input:checked + label {
  color: #AA0066;
}
.radio-input:checked + label::after {
  content: '';
  display: block;
  position: absolute;
  top: 12px;
  left: 2px;
  width: 11px;
  height: 11px;
  background: #AA0066;
  border-radius: 50%;
}

.no-template {
  margin-top: 128px;
  text-align: center;
}

.template-label {
  border-bottom: solid 1px #AA0066;
  cursor: pointer;
}

.template-row {
  display: flex;
  margin-top: 8px;
}

.edit-btn {
  padding: 0;
  height: 32px;
  width: 32px;
  border-radius: 50%;
  z-index: 10;
  border: solid 1.5px #a22;
  color: #a22;
}
</style>


// WEBPACK FOOTER //
// src/components/organisms/contents/ExportModalContent.vue